import { render, staticRenderFns } from "./Vertek.vue?vue&type=template&id=5ea8200e&"
import script from "./Vertek.vue?vue&type=script&lang=js&"
export * from "./Vertek.vue?vue&type=script&lang=js&"
import style0 from "../Wizard.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports